<script>
import Drawer from "@/components/drawer";
import Swal from "sweetalert2";
import MultiSelect from "vue-multiselect";

// Custom Components
import PageHeader from "@/components/page-header";
import GatewayDrawer from "@/components/superAdmin/IOTLock/Gateway.vue";
import superService from "@/helpers/APIService/super.service";
import errorHandler from "@/helpers/errorHandler";
import Middleware from "@/helpers/middlewares";

import appConfig from "@/app.config";

export default {
  page: {
    title: "Gateway",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      title: "List Of IOT Gateway",
      isLoading: false,
      table: {
        tableData: [],
        size: 100,
        next: null,
        previous: null,
      },
      hotels: [],
      deviceModelList: [],
      filters: {
        hotel: { text: "All", value: "all" },
        status: "all",
      },
      isChangeFilterValue: false,
      isApplyFilter: false,
      addGatewayModel: false,
      isEdit: false,
      gatewayId: null,
      gateway: null,
    };
  },
  computed: {
    guestwayProps() {
      return {
        gatewayId: this.gatewayId,
        isEdit: this.isEdit,
        gateway: this.gateway,
      };
    },
  },
  components: {
    PageHeader,
    Drawer,
    GatewayDrawer,
    MultiSelect,
  },
  mounted() {
    this.getGateways("?size=" + this.table.size);
    this.getHotels();
  },
  methods: {
    // Method is used to get gateway list
    async getGateways(query) {
      this.isLoading = true;
      try {
        const response = await superService.getGatewayList(query);
        if (response) {
          this.table.previous = response.previous;
          this.table.next = response.next;
          this.table.tableData = response.results;
          this.isLoading = false;
        }
      } catch (error) {
        this.isLoading = false;
        errorHandler(error);
      }
    },
    // Method is used to get hotel list
    async getHotels() {
      if (localStorage.hotels) {
        this.hotels = JSON.parse(atob(localStorage.getItem("hotels")));
      } else {
        this.hotels = await Middleware.hotelList();
      }
    },
    // Method is used to handle drawer
    addGatewayDrawer(isEdit) {
      if (typeof isEdit !== "boolean") {
        this.isEdit = false;
        this.gatewayId = null;
        this.gateway = null;
      }
      this.addGatewayModel = !this.addGatewayModel;
    },
    // Method is use update and add new guest in guest list table
    handleSubmit({ data, isEdit }) {
      if (isEdit) {
        this.table.tableData = this.table.tableData.map((item) => {
          if (item.id == data.id) {
            item = data;
          }
          return item;
        });
      } else {
        this.table.tableData.push(data);
      }
      this.isEdit = false;
      this.gatewayId = null;
      this.gateway = null;
      this.addGatewayDrawer();
      Middleware.notification(
        `${isEdit ? "Updated successfully !!" : "Added successfully !!"}`,
        "success"
      );
    },
    // Method is used to edit gateway
    editGateway(gateway) {
      this.isEdit = true;
      this.gateway = gateway;
      this.gatewayId = gateway.id;
      this.addGatewayDrawer(this.isEdit);
    },
    // Method is used to change status
    changeStatus(gateway) {
      let gatewayData = new FormData();
      gatewayData.append("is_active", gateway.is_active);
      superService
        .editGateWayData(gateway.id, gatewayData)
        .then(() => {
          Middleware.notification("Successfully changed !!", "success");
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is used to delete gateway
    deleteGateway(gateway_id) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          superService
            .deleteGateway(gateway_id)
            .then(() => {
              this.table.tableData = this.table.tableData.filter(
                (gateway) => gateway.id !== gateway_id
              );
              Middleware.notification("Successfully deleted !!", "danger");
            })
            .catch((error) => {
              errorHandler(error);
            });
        }
      });
    },
    // Method is used to get more guest
    loadMore: function () {
      if (this.table.next !== null) {
        const str = this.table.next.split("?");
        this.getGateways(`?${str[1]}`);
      }
    },
    // Method is used to handle status based filter
    handleStatusFilter() {
      this.isChangeFilterValue = true;
    },
    // Method is used to apply filter
    applyFilter() {
      if (this.isApplyFilter) {
        this.filters = {
          hotel: { text: "All", value: "all" },
          status: "all",
        };
        this.isApplyFilter = false;
        return this.getGateways("?size=" + this.table.size);
      }
      if (this.isChangeFilterValue) {
        this.isApplyFilter = true;
        let filter = "";
        if (this.filters.hotel.value !== "all") {
          filter += `?hotel=${this.filters.hotel.value}`;
        }
        if (this.filters.status !== "all") {
          filter += `${filter == "" ? "?" : "&"}is_active=${
            this.filters.status
          }`;
        }
        this.getGateways(filter);
      }
    },
  },
};
</script>

<template>
  <div>
    <PageHeader
      :title="title"
      text="Add New"
      :isButton="true"
      :action="addGatewayDrawer"
    />
    <div
      v-infinite-scroll="loadMore"
      infinite-scroll-disabled="isLoading"
      infinite-scroll-distance="100"
    >
      <div class="card">
        <div class="card-body">
          <div class="row">
            <!-- Filter gateway by hotel -->
            <div class="col-xl-3 col-lg-5 col-md-6 col-sm-8">
              <MultiSelect
                class="mb-2"
                v-model="filters.hotel"
                :options="hotels"
                :show-labels="false"
                placeholder="Select Hotel"
                track-by="value"
                label="text"
                name="hotels"
                :allow-empty="false"
                @close="handleStatusFilter()"
              />
            </div>
            <!-- Filter gateway by status -->
            <div class="col-xl-2 col-lg-3 col-md-4 col-sm-4">
              <select
                name="is_active"
                id="is_active"
                class="form-control mb-2"
                v-model="filters.status"
                placeholder="by is active"
                @change="handleStatusFilter()"
              >
                <option value="all">All</option>
                <option value="true">Active</option>
                <option value="false">Inactive</option>
              </select>
            </div>
            <div class="col-xl-2 col-lg-3 col-md-2">
              <b-button
                variant="primary"
                class="float-end float-md-start mb-2"
                @click="applyFilter"
                >{{
                  !isApplyFilter ? "Apply Filter" : "Clear Filter"
                }}</b-button
              >
            </div>
          </div>
          <div class="table-responsive mb-0">
            <v-table
              :data="table.tableData"
              class="table table-hover mb-0"
              ref="my-table"
            >
              <thead class="table-light" slot="head">
                <tr>
                  <th>Mac</th>
                  <v-th sortKey="name">Device name</v-th>
                  <th>hotel</th>
                  <th>Device Ip</th>
                  <th>Created by</th>
                  <th>Last Config</th>
                  <th>Description</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody
                class="infinite-list"
                slot="body"
                slot-scope="{ displayData }"
                v-if="!isLoading && table.tableData.length !== 0"
              >
                <tr v-for="(gateway, index) in displayData" :key="index">
                  <td @click="editGateway(gateway)">
                    {{
                      gateway.mac_address !== null ? gateway.mac_address : "-"
                    }}
                  </td>

                  <td @click="editGateway(gateway)">
                    {{ gateway.name !== null ? gateway.name : "-" }}
                  </td>
                  <td @click="editGateway(gateway)">
                    {{ gateway.hotel !== null ? gateway.hotel.name : "-" }}
                  </td>
                  <td @click="editGateway(gateway)">
                    {{ gateway.ip_address !== null ? gateway.ip_address : "-" }}
                  </td>
                  <td @click="editGateway(gateway)">
                    {{ gateway.created_by !== null ? gateway.created_by : "-" }}
                  </td>

                  <td @click="editGateway(gateway)">
                    {{
                      gateway.description !== null ? gateway.description : "-"
                    }}
                  </td>
                  <td @click="editGateway(gateway)">
                    {{
                      global_format_date_and_time_custom(
                        gateway.last_config_at,
                        "YYYY-MM-DD hh:mm A"
                      )
                    }}
                  </td>
                  <td>
                    <div class="form-check form-switch my-1" slot="is_active">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="gateway.is_active"
                        @change="
                          changeStatus({
                            id: gateway.id,
                            is_active: gateway.is_active,
                          })
                        "
                      />
                    </div>
                  </td>
                  <td>
                    <i
                      class="fas fa-pencil-alt text-success mx-1"
                      v-b-popover.hover="'Edit recored'"
                      id="edit"
                      @click="editGateway(gateway)"
                    ></i>
                    <i
                      class="mdi mdi-trash-can text-danger fs-5 mx-1"
                      v-b-popover.hover="'View card details'"
                      @click="deleteGateway(gateway.id)"
                    ></i>
                  </td>
                </tr>
              </tbody>
              <tbody slot="body" v-else-if="isLoading">
                <tr v-for="item in 10" :key="item">
                  <td class="placeholder-glow" v-for="no in 9" :key="no">
                    <span class="placeholder w-100 placeholder-lg"></span>
                  </td>
                </tr>
              </tbody>
              <tbody slot="body" v-else>
                <tr>
                  <td colspan="9" class="text-center">
                    <img
                      src="@/assets/images/empty.svg"
                      class="img-fluid"
                      alt=""
                    />
                    <p>
                      <span class="text-secondary">No Data Found</span>
                    </p>
                  </td>
                </tr>
              </tbody>
            </v-table>
          </div>
        </div>
      </div>
    </div>

    <!-- Drawer -->
    <Drawer
      @close="addGatewayDrawer"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :maxWidth="800"
      :zIndex="1002"
    >
      <div v-if="addGatewayModel">
        <GatewayDrawer
          :currentProps="guestwayProps"
          @submitted="handleSubmit"
          @cancelSubmit="addGatewayDrawer()"
        ></GatewayDrawer>
      </div>
    </Drawer>
  </div>
</template>
